
const hasPermission = (user, permission) =>
    user && user.permissions && user.permissions.split(',').findIndex(p =>
      p === '*' ||
      (p.split(':')[0] === permission.split(':')[0] && (
        p.split(':')[1] === '*' || p.split(':')[1] === permission.split(':')[1])
      )
    ) !== -1
  
  export default hasPermission
  